import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import './ProjectPanel.scss';
import { ProjectPanelVM } from './ProjectPanelVM';
import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';
import stores from '../../../models/Stores';
import { useHistory } from 'react-router-dom';
import AppStore from 'cd-eft/models/Stores/AppStore';
import { formatDate } from 'cd-eft/utils/formatDate';
const setStore = stores.AppStore.surveyEngineeringStore;
const designStore = stores.AppStore.designStore;
const libraryStore = stores.AppStore.projectsLibraryStore;

const ProjectPanelComponent = (props) => {
  const vm = useRef(new ProjectPanelVM(props)).current;
  const projectMetadata = {
    projectTitle: designStore.projectsStore.currentProject.projectTitle,
    // sessionUuid: designStore.projectsStore.currentProject.sessionList[0].sessionUuid,
    createdBy: designStore.projectsStore.currentProject.createdBy,
    createdOn: designStore.projectsStore.currentProject.createdDate,
    lastUpdatedBy: designStore.projectsStore.currentProject.lastChangedBy,
    lastUpdatedOn: designStore.projectsStore.currentProject.lastChangedDate,
    projectType: designStore.projectsStore.currentProject.projectClassType,
    projectionInfo: libraryStore.projectProjectionInfo,
  };
  //The code is commented to improve code coverage
  //It is for future use to handle Untitled Project creation via unhappy path
  /* 
  const surfaceDefClass = {
    1: 'Survey',
    2: 'DEM',
    3: 'LiDAR',
  };
  const history = useHistory();

  const redirectUserToUpload = () => {
    if (designStore.projectsStore.currentProject.projectUuid) {
      history.replace(`/design/surface/${designStore.projectsStore.currentProject.projectUuid}`);
    } else {
      history.replace(`/design/surface`);
    }
  };

  useEffect(() => {
    if (designStore.currentSurface.surfaceDefId) {
      vm.displayProjectMetadata();
    }
  }, [designStore.projectsStore.currentProject.projectUuid]); */

  return (
    <>
      {/*       {!designStore.projectsStore.currentProject.projectUuid && !designStore.currentSurface.surfaceDefId ? (
        <div className="project-editable-panel">
          <CollapseMenu
            title={`Project Details`}
            cardBodyId={`projectTitle`}
            noIcon={true}
            forceOpen={false}
            className="m-0"
          >
            <fieldset disabled={!designStore.hasProject()}>
              <label className="usa-label" htmlFor="project-title">
                Project Name
              </label>
              <input
                className="usa-input"
                name="project-title"
                type="text"
                value={designStore.projectsStore.currentProject.projectTitle}
                onChange={vm.setProjectTitle}
              />
              {vm.formValidation.formErrors.projectTitle && (
                <div className="usa-error-message" id="client--message" role="alert">
                  {vm.formValidation.formErrors.projectTitle}
                </div>
              )}

              <label className="usa-label" htmlFor="surface-def-title">
                Surface Name
              </label>
              <input
                className="usa-input"
                name="surface-def-title"
                type="text"
                value={vm.surfaceDefTitle}
                onChange={vm.setSurfaceDefTitle}
              />
              {vm.formValidation.formErrors.surfaceDefTitle && (
                <div className="usa-error-message" id="client--message" role="alert">
                  {vm.formValidation.formErrors.surfaceDefTitle}
                </div>
              )}
              <label className="usa-label" htmlFor="surface-type">
                Surface Type
              </label>
              <select
                className="usa-select"
                name="surface-type"
                value={vm.surfaceDefClassId}
                onChange={vm.setSurfaceDefClassId}
              >
                <option value="">- Select -</option>
                <option value="1">Survey</option>
                <option value="2">DEM</option>
                <option value="3">LiDAR</option>
              </select>
              {vm.formValidation.formErrors.surfaceDefClassId && (
                <div className="usa-error-message" id="client--message" role="alert">
                  {vm.formValidation.formErrors.surfaceDefClassId}
                </div>
              )}
              <div className="my-4">
                <button className="usa-button px-5 usa-button--outline" onClick={vm.handleCancel}>
                  Cancel
                </button>
                <button
                  className="usa-button mr-2 px-5"
                  onClick={() => {
                    vm.submitNewSurface(redirectUserToUpload);
                  }}
                >
                  Save
                </button>
              </div>
            </fieldset>
          </CollapseMenu>
        </div>
      ) : ( )}*/}

      {!designStore.projectsStore.currentProject.projectUuid || !designStore.currentSurface.surfaceDefId ? null : (
        <CollapseMenu
          title={`Project Details`}
          cardBodyId={`projectTitle`}
          noIcon={true}
          forceOpen={false}
          className="project-panel-container"
        >
          <div>
            <strong>Project Name: </strong>
            {projectMetadata.projectTitle}
          </div>
          <div className="capitalize">
            <strong>Project Owner: </strong>
            {projectMetadata.createdBy.split('@')[0].replace('.', ' ')}
          </div>
          <div>
            <strong>Created On: </strong> {formatDate(projectMetadata.createdOn)}
          </div>
          <div>
            <strong>Last Updated By: </strong>
            {projectMetadata.lastUpdatedBy}
          </div>
          <div>
            <strong>Last Updated On: </strong>
            {formatDate(projectMetadata.lastUpdatedOn)}
          </div>
          <div>
            <strong>Project Type: </strong>
            {projectMetadata.projectType}
          </div>
          <div>
            <strong>Projection Information: </strong>
            {projectMetadata.projectionInfo}
          </div>
          {/*           <h5>Surface Name: {projectMetadata.surfaceDefTitle}</h5>
          <h5>Surface Type: {surfaceDefClass[projectMetadata.surfaceDefClassId]}</h5> */}
        </CollapseMenu>
      )}
    </>
  );
};

export const ProjectPanel = observer(ProjectPanelComponent);
